/* Light up the dot for whichever comparison card is in view.
 *
 * Phones only: the cards scroll-snap sideways under 768px, and above that the
 * section is an ordinary table with nothing to track. Uses IntersectionObserver
 * against the scroller so it costs nothing on scroll, and does nothing at all
 * if the markup is absent (the dots only render for 2+ rivals). */
(function () {
  function init(root) {
    var scroller = root.querySelector('.product-comparison-slider');
    var dots = root.querySelectorAll('.product-comparison-dots__dot');
    if (!scroller || dots.length < 2) return;

    var cards = root.querySelectorAll('thead th:not(.product-comparison-grid__th--left)');
    if (cards.length !== dots.length) return;

    // Take the LEFTMOST intersecting card, not the last entry the observer
    // happens to report. On first paint every card can report as intersecting
    // (the scroller has not laid out its clip yet), and iterating blindly
    // leaves the FINAL card lit while the reader is looking at the first.
    var observer = new IntersectionObserver(function (entries) {
      var best = -1;
      var bestLeft = Infinity;
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var i = Array.prototype.indexOf.call(cards, entry.target);
        if (i < 0) return;
        var left = entry.boundingClientRect.left;
        if (left < bestLeft) {
          bestLeft = left;
          best = i;
        }
      });
      if (best < 0) return;
      dots.forEach(function (d, n) {
        d.classList.toggle('is-active', n === best);
      });
    }, { root: scroller, threshold: 0.6 });

    cards.forEach(function (c) { observer.observe(c); });
  }

  function boot() {
    document.querySelectorAll('product-comparison-grid').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
